import { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart3, ArrowUpDown, ChevronRight } from 'lucide-react';
import api from '@/lib/api';

export function HoursWeekCard({ navigate }) {
  const [data, setData] = useState(null);
  const [sortBy, setSortBy] = useState('hours');

  useEffect(() => {
    api.get('/dashboard/hours-week')
      .then(r => setData(r.data))
      .catch(() => setData({ by_project: [], total_hours: 0 }));
  }, []);

  if (!data) return null;
  const rows = [...(data.by_project || [])];
  if (sortBy === 'name') rows.sort((a, b) => a.label.localeCompare(b.label));
  const max = Math.max(...rows.map(r => r.hours), 0.01);

  return (
    <Card className="border-white/10 bg-card shadow-none" data-testid="hours-week-card">
      <CardHeader className="pb-2 border-b border-white/[0.08]">
        <CardTitle className="text-sm font-medium flex items-center gap-2">
          <BarChart3 className="h-3.5 w-3.5 text-primary shrink-0" /> Hours This Week
          <span className="text-xs text-muted-foreground/70 font-normal tabular-nums" data-testid="hours-week-total">{data.total_hours || 0}h total</span>
          <button
            type="button"
            className="ml-auto flex items-center gap-1 text-xs text-muted-foreground hover:text-primary transition-colors"
            onClick={() => setSortBy(s => (s === 'hours' ? 'name' : 'hours'))}
            title="Toggle sort"
            data-testid="hours-week-sort-toggle"
          >
            <ArrowUpDown className="h-3 w-3" /> {sortBy === 'hours' ? 'By hours' : 'By project'}
          </button>
          <button type="button" className="flex items-center text-muted-foreground hover:text-primary transition-colors" onClick={() => navigate('/timesheets')} aria-label="View my timesheets" data-testid="hours-week-link">
            <ChevronRight className="h-3.5 w-3.5" />
          </button>
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-3 space-y-2">
        {rows.length === 0 ? (
          <p className="text-xs text-muted-foreground">No hours logged this week yet</p>
        ) : (
          rows.map(r => (
            <div key={r.label} className="flex items-center gap-2" data-testid={`hours-week-row-${r.label.replace(/\s+/g, '-')}`}>
              <span className="text-xs text-muted-foreground truncate w-2/5" title={r.label}>{r.label}</span>
              <div className="flex-1 h-2 rounded-full bg-white/10 overflow-hidden">
                <div className="h-full bg-primary rounded-full transition-all" style={{ width: `${Math.max(2, (r.hours / max) * 100)}%` }} />
              </div>
              <span className="text-xs font-mono tabular-nums w-12 text-right">{r.hours}h</span>
            </div>
          ))
        )}
      </CardContent>
    </Card>
  );
}
